const StarRating = ({ numberOfStars }) => {
    // Generate an array of size "numberOfStars" filled with null values
    const starsArray = Array.from({ length: numberOfStars });
  
    return (
      <>
        {starsArray.map((_, index) => (
          <i key={index} className="ri-star-fill fill"></i>
        ))}
        {/* Add the remaining empty stars */}
        {Array.from({ length: 5 - numberOfStars }).map((_, index) => (
          <i key={index + numberOfStars} className="ri-star-fill"></i>
        ))}
        </>
    );
  }; 
  export default StarRating;
